import React from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

const PostImage = ({ image, alt = '' }) => {
  const featuredImage = image?.node?.localFile
  return <GatsbyImage image={getImage(featuredImage)} alt={alt} />
}

export default PostImage
